import {Component, inject, OnInit, output, signal} from '@angular/core'
import {getTakeUntilDestroyed} from '@sparbanken-syd/sparbanken-syd-theme'
import {filter} from 'rxjs/operators'
import {KalpService, LegacyKalp} from '../../../services/kalp.service'
import {EmailAndPhoneComponent} from '../email-and-phone/email-and-phone.component'

@Component({
  selector: 'spb-contact-holder',
  templateUrl: './contact-holder.component.html',
  styleUrls: [],
  imports: [EmailAndPhoneComponent]
})
export class ContactHolderComponent implements OnInit {

  public formStatusChanged = output<boolean>()
  public coApplicant = signal(false)

  private readonly takeUntilDestroyed = getTakeUntilDestroyed()
  private readonly kalpService = inject(KalpService)

  public ngOnInit(): void {
    this.kalpService.kalpResult$
      .pipe(
        this.takeUntilDestroyed(),
        filter<LegacyKalp[]>((kalps: LegacyKalp[]) =>
          Array.isArray(kalps) && kalps[0]?.applicants !== undefined)
      )
      .subscribe(kalps => {
        this.coApplicant.set(kalps[0].applicants.length > 1)
      })
  }

  /**
   * Tells the sign button if the form is valid
   * @param isValid
   */
  public onFormStatusChanged(isValid: boolean) {
    this.formStatusChanged.emit(isValid)
  }
}
